import { useState, useEffect } from 'react'
import Phone from 'services/Phone'
import CountrySelect from '../CountrySelect'

import {
  Container,
  PhoneInputWrapper,
  MaskedInput
} from './styles'

export default function PhoneInput ({
  name,
  value = '',
  defaultCountry = 'BR',
  placeholder,
  error,
  touched,
  onChange: handleChange,
  onBlur: handleBlur = () => null,
  disabled = false,
  ...props
}) {
  const [phoneData, setPhoneData] = useState (Phone.fromE164 (value || ''))

  const [selectedCountry, setSelectedCountry] = useState (() => {
    const initialPhoneData = Phone.fromE164 (value || '')
    const countryCode = initialPhoneData.countryCode || defaultCountry

    return Phone.getCountryByCode (countryCode) || Phone.getDefaultCountry ()
  })

  useEffect (() => {
    const newPhoneData = Phone.fromE164 (value || '')
    setPhoneData (newPhoneData)
    
    if (newPhoneData.countryCode !== selectedCountry.code) {
      const newCountry = Phone.getCountryByCode (newPhoneData.countryCode)
      if (newCountry) {
        setSelectedCountry (newCountry)
      }
    }
  }, [value])

  const handleCountryChange = option => {
    const newCountry = Phone.getCountryByCode (option.value)

    if (newCountry) {
      setSelectedCountry (newCountry)
      
      const newPhoneData = {
        countryCode: newCountry.code,
        number: ''
      }
      
      setPhoneData (newPhoneData)
      handleChange (name, Phone.toE164 (newPhoneData))
    }
  }

  const handlePhoneNumberChange = event => {
    const { rawValue } = event.target

    const newPhoneData = {
      countryCode: selectedCountry.code,
      number: rawValue
    }
    
    setPhoneData (newPhoneData)
    handleChange (name, Phone.toE164 (newPhoneData))
  }

  const countryOptions = Phone.getCountryOptions ()
  
  const currentCountryOption = countryOptions.find (
    option => option.value === selectedCountry.code
  )

  const inputPlaceholder = placeholder || selectedCountry.placeholder

  return (
    <Container {...props} disabled={disabled}>
      <CountrySelect
        value={currentCountryOption}
        options={countryOptions}
        onChange={handleCountryChange}
        disabled={disabled}
      />
      <PhoneInputWrapper>
        <MaskedInput
          key={selectedCountry.code}
          name={name}
          placeholder={inputPlaceholder}
          options={selectedCountry.maskConfig}
          value={phoneData.number || ''}
          onChange={handlePhoneNumberChange}
          onBlur={() => handleBlur (name, true)}
          disabled={disabled}
        />
      </PhoneInputWrapper>
    </Container>
  )
}
